import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortAlphabetically',
  standalone: true
})
export class SortAlphabeticallyPipe implements PipeTransform {
  transform<T extends string>(value: readonly T[]): T[] {
    if (!value) {
      return [];
    }
    return [...value].sort((a, b) => {
      const aValue = a ?? '';
      const bValue = b ?? '';
      return aValue.localeCompare(bValue);
    });
  }
}
